// Shared gold-apple + "KNOW YORKER" wordmark used by both the nav and footer.
// The animated variant is driven by the consumer's wrapper class (e.g.
// `.kny-nav-logo`); this component only owns the SVG + text markup so both
// surfaces stay visually identical and free of duplicated markup.
export default function AppleWordmark({
  appleClassName = 'kny-nav-logo-apple',
  textClassName = 'kny-nav-logo-text',
  appleWidth = 28,
  appleHeight = 32,
}) {
  return (
    <>
      <span className={appleClassName} aria-hidden="true">
        <svg viewBox="0 0 32 36" width={appleWidth} height={appleHeight} role="presentation" focusable="false">
          <defs>
            <radialGradient id="kny-apple-body-grad" cx="38%" cy="38%" r="70%">
              <stop offset="0%" stopColor="#f5d78a" />
              <stop offset="55%" stopColor="#c9a86a" />
              <stop offset="100%" stopColor="#8b7440" />
            </radialGradient>
            <linearGradient id="kny-apple-leaf-grad" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stopColor="#e8c47e" />
              <stop offset="100%" stopColor="#8b7440" />
            </linearGradient>
          </defs>
          <path
            className="kny-apple-body"
            d="M16 10.4c-2.6-2.6-8.1-2.4-10.9 1.6-4 5.7-0.4 18.3 5.3 21.8 2.3 1.4 3.9-.2 5.6-.2s3.3 1.6 5.6.2c5.7-3.5 9.3-16.1 5.3-21.8-2.8-4-8.3-4.2-10.9-1.6z"
            fill="url(#kny-apple-body-grad)"
            stroke="#c9a86a"
            strokeWidth="0.6"
          />
          <path
            className="kny-apple-highlight"
            d="M11 13.6c1.4-1.4 3.4-1.8 5-1.4"
            fill="none"
            stroke="#fff2c9"
            strokeOpacity="0.55"
            strokeWidth="1.1"
            strokeLinecap="round"
          />
          <path
            className="kny-apple-stem"
            d="M16 10c0-2.2-.4-4.4-1.5-6.1"
            fill="none"
            stroke="#5a4a24"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <path
            className="kny-apple-leaf"
            d="M16.4 8.6c.2-3.8 3-6.4 7.4-7-.3 4-2.9 6.4-7.4 7z"
            fill="url(#kny-apple-leaf-grad)"
            stroke="#8b7440"
            strokeWidth="0.5"
          />
        </svg>
      </span>
      <span className={textClassName}>
        <span className="kny-nav-logo-prefix">KNOW</span>
        <span className="kny-nav-logo-word" aria-label="YORKER">YORKER</span>
      </span>
    </>
  );
}